<!-- компонент для отображения списка услуг врача дляrec.component.html-->
<div class="srv__wrapper">
    <div class="srv__top">
        <button class="srv__top-close">
            <img
                src="./assets/icons/navigation/back.svg"
                alt="Закрыть фильтр"
                (click)="closeSrvListHandler()"
            />
        </button>
        <div class="srv__top-title">Выбор услуги</div>
    </div>

    <div class="srv__list">
        <div
            class="srv__option"
            *ngFor="let srv of srvList"
            (click)="srvPicked(srv)"
        >
            <div class="srv__option-text">
                {{srv.text}}
                <button
                    *ngIf="srv.description"
                    class="srv__option-info"
                    (click)="openServDescModal(srv, $event)"
                >
                    <img src="./assets/icons/actions/information.svg" />
                </button>
            </div>
            <div class="srv__option-price">
                <span *ngIf="srv.price != 0"
                    >{{ srv.price | priceSpace : "1.2-2" }} руб.</span
                >
                <!-- <span *ngIf="srv.price == 0">Бесплатно</span> -->

                <div class="srv__option-price-icon">
                    <img
                        *ngIf="srv.isCreatePayOrder == 1"
                        src="./assets/icons/payments/ruble.svg"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
